// Expo Router API
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
0 && (module.exports = {
    Badge: null,
    DarkTheme: null,
    DefaultTheme: null,
    ErrorBoundary: null,
    ExperimentalStack: null,
    ExpoRoot: null,
    Icon: null,
    IsWithinNativeNavigator: null,
    Label: null,
    LocaleProvider: null,
    NativeStackView: null,
    NavigationAwareActivity: null,
    Navigator: null,
    RouterActionHandling: null,
    Sitemap: null,
    Slot: null,
    SplashScreen: null,
    StackRouter: null,
    SuspenseFallback: null,
    TabRouter: null,
    Tabs: null,
    ThemeProvider: null,
    Unmatched: null,
    VectorIcon: null,
    attachRouteState: null,
    createBaseStackProps: null,
    createBaseTabProps: null,
    createNativeStackProps: null,
    createStandardRouterNavigator: null,
    enableLegacyHeaderAppearance: null,
    extendRouter: null,
    extendRouterActions: null,
    integrateWithRouter: null,
    isActionHandled: null,
    router: null,
    unstable_PerformanceObserver: null,
    unstable_createStandardRouterNavigator: null,
    unstable_enablePerformanceIntegration: null,
    unstable_integrateWithRouter: null,
    unstable_performance: null,
    unstable_useIsNavigating: null,
    unstable_useReconcileTabHistory: null,
    useCanDismiss: null,
    useCanGoBack: null,
    useCurrentRouteInfo: null,
    useFocusEffect: null,
    useGlobalSearchParams: null,
    useIsFocused: null,
    useLoaderData: null,
    useLocalSearchParams: null,
    useNavigation: null,
    useNavigationContainerRef: null,
    usePathname: null,
    usePreventRemove: null,
    useRootNavigation: null,
    useRootNavigationState: null,
    useRoute: null,
    useRoutePath: null,
    useRouter: null,
    useScrollToTop: null,
    useSegments: null,
    useSitemap: null,
    useTheme: null,
    useUnstableGlobalHref: null,
    withLayoutContext: null
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get Badge () {
        return _primitives.Badge;
    },
    get DarkTheme () {
        return _DarkTheme.DarkTheme;
    },
    get DefaultTheme () {
        return _DefaultTheme.DefaultTheme;
    },
    get ErrorBoundary () {
        return _ErrorBoundary.ErrorBoundary;
    },
    get ExperimentalStack () {
        return _experimentalstack.ExperimentalStack;
    },
    get ExpoRoot () {
        return _ExpoRoot.ExpoRoot;
    },
    get Icon () {
        return _primitives.Icon;
    },
    get IsWithinNativeNavigator () {
        return _standardnavigation.IsWithinNativeNavigator;
    },
    get Label () {
        return _primitives.Label;
    },
    get LocaleProvider () {
        return _LocaleProvider.LocaleProvider;
    },
    get NativeStackView () {
        return _nativestack.NativeStackView;
    },
    get NavigationAwareActivity () {
        return _NavigationAwareActivity.NavigationAwareActivity;
    },
    get Navigator () {
        return _Navigator.Navigator;
    },
    get RouterActionHandling () {
        return _routers.RouterActionHandling;
    },
    get Sitemap () {
        return _Sitemap.Sitemap;
    },
    get Slot () {
        return _Navigator.Slot;
    },
    get SplashScreen () {
        return _Splash;
    },
    get StackRouter () {
        return _routers.StackRouter;
    },
    get SuspenseFallback () {
        return _SuspenseFallback.SuspenseFallback;
    },
    get TabRouter () {
        return _routers.TabRouter;
    },
    get Tabs () {
        return _Tabs.Tabs;
    },
    get ThemeProvider () {
        return _ThemeProvider.ThemeProvider;
    },
    get Unmatched () {
        return _Unmatched.Unmatched;
    },
    get VectorIcon () {
        return _primitives.VectorIcon;
    },
    get attachRouteState () {
        return _routers.attachRouteState;
    },
    get createBaseStackProps () {
        return _createBaseStackProps.createBaseStackProps;
    },
    get createBaseTabProps () {
        return _createBaseTabProps.createBaseTabProps;
    },
    get createNativeStackProps () {
        return _createNativeStackProps.createNativeStackProps;
    },
    get createStandardRouterNavigator () {
        return _standardnavigation.createStandardRouterNavigator;
    },
    get enableLegacyHeaderAppearance () {
        return _headerAppearance.enableLegacyHeaderAppearance;
    },
    get extendRouter () {
        return _routers.extendRouter;
    },
    get extendRouterActions () {
        return _routers.extendRouterActions;
    },
    get integrateWithRouter () {
        return _standardnavigation.integrateWithRouter;
    },
    get isActionHandled () {
        return _routers.isActionHandled;
    },
    get router () {
        return _imperativeapi.router;
    },
    get unstable_PerformanceObserver () {
        return _performance.unstable_PerformanceObserver;
    },
    get unstable_createStandardRouterNavigator () {
        return _standardnavigation.unstable_createStandardRouterNavigator;
    },
    get unstable_enablePerformanceIntegration () {
        return _performance.unstable_enablePerformanceIntegration;
    },
    get unstable_integrateWithRouter () {
        return _standardnavigation.unstable_integrateWithRouter;
    },
    get unstable_performance () {
        return _performance.unstable_performance;
    },
    get unstable_useIsNavigating () {
        return _useIsNavigating.useIsNavigating;
    },
    get unstable_useReconcileTabHistory () {
        return _useReconcileTabHistory.useReconcileTabHistory;
    },
    get useCanDismiss () {
        return _hooks.useCanDismiss;
    },
    get useCanGoBack () {
        return _hooks.useCanGoBack;
    },
    get useCurrentRouteInfo () {
        return _hooks.useCurrentRouteInfo;
    },
    get useFocusEffect () {
        return _useFocusEffect.useFocusEffect;
    },
    get useGlobalSearchParams () {
        return _hooks.useGlobalSearchParams;
    },
    get useIsFocused () {
        return _useIsFocused.useIsFocused;
    },
    get useLoaderData () {
        return _hooks.useLoaderData;
    },
    get useLocalSearchParams () {
        return _hooks.useLocalSearchParams;
    },
    get useNavigation () {
        return _useNavigation.useNavigation;
    },
    get useNavigationContainerRef () {
        return _hooks.useNavigationContainerRef;
    },
    get usePathname () {
        return _hooks.usePathname;
    },
    get usePreventRemove () {
        return _usePreventRemove.usePreventRemove;
    },
    get useRootNavigation () {
        return _hooks.useRootNavigation;
    },
    get useRootNavigationState () {
        return _hooks.useRootNavigationState;
    },
    get useRoute () {
        return _useRoute.useRoute;
    },
    get useRoutePath () {
        return _useRoutePath.useRoutePath;
    },
    get useRouter () {
        return _hooks.useRouter;
    },
    get useScrollToTop () {
        return _useScrollToTop.useScrollToTop;
    },
    get useSegments () {
        return _hooks.useSegments;
    },
    get useSitemap () {
        return _useSitemap.useSitemap;
    },
    get useTheme () {
        return _useTheme.useTheme;
    },
    get useUnstableGlobalHref () {
        return _hooks.useUnstableGlobalHref;
    },
    get withLayoutContext () {
        return _withLayoutContext.withLayoutContext;
    }
});
const _Navigator = require("./views/Navigator");
const _hooks = require("./hooks");
const _imperativeapi = require("./imperative-api");
const _useIsNavigating = require("./global-state/useIsNavigating");
const _withLayoutContext = require("./layouts/withLayoutContext");
const _ExpoRoot = require("./ExpoRoot");
const _Unmatched = require("./views/Unmatched");
const _Sitemap = require("./views/Sitemap");
const _useSitemap = require("./views/useSitemap");
const _ErrorBoundary = require("./views/ErrorBoundary");
const _SuspenseFallback = require("./views/SuspenseFallback");
const _NavigationAwareActivity = require("./views/NavigationAwareActivity");
const _Splash = /*#__PURE__*/ _interop_require_wildcard(require("./views/Splash"));
const _useNavigation = require("./useNavigation");
const _useFocusEffect = require("./useFocusEffect");
const _useIsFocused = require("./useIsFocused");
const _DarkTheme = require("./react-navigation/native/theming/DarkTheme");
const _DefaultTheme = require("./react-navigation/native/theming/DefaultTheme");
const _ThemeProvider = require("./react-navigation/core/theming/ThemeProvider");
const _useTheme = require("./react-navigation/core/theming/useTheme");
const _LocaleProvider = require("./LocaleProvider");
const _useRoutePath = require("./react-navigation/native/useRoutePath");
const _useScrollToTop = require("./react-navigation/native/useScrollToTop");
const _useRoute = require("./react-navigation/core/useRoute");
const _usePreventRemove = require("./react-navigation/core/usePreventRemove");
const _primitives = require("./primitives");
const _standardnavigation = require("./standard-navigation");
const _useReconcileTabHistory = require("./standard-navigation/useReconcileTabHistory");
const _createBaseStackProps = require("./layouts/stack-utils/createBaseStackProps");
const _createBaseTabProps = require("./layouts/createBaseTabProps");
const _createNativeStackProps = require("./layouts/createNativeStackProps");
const _routers = require("./react-navigation/routers");
const _nativestack = require("./react-navigation/native-stack");
const _headerAppearance = require("./react-navigation/native-stack/views/headerAppearance");
const _performance = require("./performance");
const _Tabs = require("./layouts/Tabs");
const _experimentalstack = require("./layouts/experimental-stack");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}

//# sourceMappingURL=exports.js.map
